// inventoryFilters.slice.js

const initialState = {};

export const SET_FILTERS = 'SET_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';

export const setFilters = (filters) => ({
    type: SET_FILTERS,
    payload: filters,
});

export const clearFilters = () => ({
    type: CLEAR_FILTERS,
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_FILTERS:
            return {
                ...state,
                ...(action.payload.bankAccount && { bankAccount: action.payload.bankAccount }),
                ...(action.payload.startDate && { startDate: action.payload.startDate }),
                ...(action.payload.endDate && { endDate: action.payload.endDate }),
                ...(action.payload.amount && { amount: action.payload.amount }),
                ...(action.payload.description && { description: action.payload.description }),
            };

        case CLEAR_FILTERS:
            return initialState;

        default:
            return state;
    }
}
